export const withoutUndefinedValues = (obj: Record<string, string | undefined>): Record<string, string> =>
  Object.fromEntries(
    Object.entries(obj).filter(
      (entry: [string, string | undefined]): entry is [string, string] => typeof entry[1] !== "undefined"
    )
  );
